/**
 * Admin APIs for Settings → Chatbot (widget flags, prompts, RAG) via tenant-user-dashboard BFF.
 */

import { tenantApiFetch, tenantDashboardPath } from "@/lib/tenantApi";

const WIDGET = () => tenantDashboardPath("/workspace/widget-feature-flags");
const PROMPTS = () => tenantDashboardPath("/workspace/llm-prompts");
const RAG = () => tenantDashboardPath("/workspace/rag-settings");

export class WorkspaceChatbotAdminClient {
  getWidgetFlags() {
    return tenantApiFetch(WIDGET());
  }

  /** @param {{ enableChatbot: boolean, enableHumanAgents: boolean, enableTicketSystemIntegration: boolean }} body */
  putWidgetFlags(body) {
    return tenantApiFetch(WIDGET(), { method: "PUT", body: JSON.stringify(body) });
  }

  getLlmPrompts() {
    return tenantApiFetch(PROMPTS());
  }

  /** @param {{ botCharacter: string, aiClassifier?: string | null }} body */
  putLlmPrompts(body) {
    return tenantApiFetch(PROMPTS(), { method: "PUT", body: JSON.stringify(body) });
  }

  getRagSettings() {
    return tenantApiFetch(RAG());
  }

  /** @param {{ ragEnabled: boolean, topK: number, maxContextChars: number }} body */
  putRagSettings(body) {
    return tenantApiFetch(RAG(), { method: "PUT", body: JSON.stringify(body) });
  }
}

export const workspaceChatbotAdminClient = new WorkspaceChatbotAdminClient();
